// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  height: 100%;
}

.content-container {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.attendee-avatar {
  width: 48px;
  height: 48px;
  min-width: 48px;
  min-height: 48px;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.attendee-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.attendee-avatar.no-image {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid #ffffff;
  background: linear-gradient(145deg, #f7f8fa 0%, #e9edf2 100%);
  color: #38424f;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.1px;
}

.attendee-proposal-card {
  display: flex;
  flex-direction: column;
  background: rgba(239, 239, 239, 0.5411764706);
  padding: 0.8rem;
  border-radius: 8px;
  gap: 2px;
  margin-bottom: 1rem;
}
.attendee-proposal-card .title {
  font-size: 16px;
  font-weight: bold;
  margin: 0px;
}
.attendee-proposal-card .time {
  font-size: 14px;
  color: var(--ion-color-medium);
  margin: 0px;
  display: flex;
  gap: 0.25rem;
  align-items: center;
}
.attendee-proposal-card .resource-status {
  font-size: 14px;
}
.attendee-proposal-card .body {
  display: flex;
  gap: 1rem;
}
.attendee-proposal-card .body .text-container {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.attendee-proposal-card .action-row {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

ion-button.accept-proposal {
  --border-color: #ed143d;
  --color: #ed143d;
  --border-radius: 10px;
  --border-width: 1.5px;
  --background: transparent;
  --background-activated: transparent;
  --color-activated: #ed143d;
  height: 44px;
  font-size: 13px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  margin-top: 4px;
  display: flex;
  width: -webkit-fit-content;
  width: fit-content;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/propose-new-time-list/propose-new-time-list.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AACJ;AAEE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6DAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,6CAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,mBAAA;AADF;AAEE;EACE,eAAA;EACA,iBAAA;EACA,WAAA;AAAJ;AAEE;EACE,eAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;AAAJ;AAEE;EACE,eAAA;AAAJ;AAEE;EACE,aAAA;EACA,SAAA;AAAJ;AAEI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAAN;AAGE;EACE,aAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;AADJ;;AAKA;EACE,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mCAAA;EACA,0BAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,0BAAA;EAAA,kBAAA;AAFF","sourcesContent":[":host {\n  height: 100%;\n}\n\n.content-container {\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.attendee-avatar {\n  width: 48px;\n  height: 48px;\n  min-width: 48px;\n  min-height: 48px;\n  overflow: hidden;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n  }\n\n  &.no-image {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: 1.5px solid #ffffff;\n    background: linear-gradient(145deg, #f7f8fa 0%, #e9edf2 100%);\n    color: #38424f;\n    font-size: 16px;\n    font-weight: 600;\n    letter-spacing: 0.1px;\n  }\n}\n\n.attendee-proposal-card {\n  display: flex;\n  flex-direction: column;\n  background: #efefef8a;\n  padding: 0.8rem;\n  border-radius: 8px;\n  gap: 2px;\n  margin-bottom: 1rem;\n  .title {\n    font-size: 16px;\n    font-weight: bold;\n    margin: 0px;\n  }\n  .time {\n    font-size: 14px;\n    color: var(--ion-color-medium);\n    margin: 0px;\n    display: flex;\n    gap: 0.25rem;\n    align-items: center;\n  }\n  .resource-status {\n    font-size: 14px;\n  }\n  .body {\n    display: flex;\n    gap: 1rem;\n\n    .text-container {\n      display: flex;\n      flex-direction: column;\n      gap: 0.25rem;\n    }\n  }\n  .action-row {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.5rem;\n    margin-top: 0.5rem;\n  }\n}\n\nion-button.accept-proposal {\n  --border-color: #ed143d;\n  --color: #ed143d;\n  --border-radius: 10px;\n  --border-width: 1.5px;\n  --background: transparent;\n  --background-activated: transparent;\n  --color-activated: #ed143d;\n  height: 44px;\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: none;\n  letter-spacing: 0;\n  margin-top: 4px;\n  display: flex;\n  width: fit-content;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
